import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { Portal } from "@vfit/shared/components";
import { OverlayGlobalStyle, WrapperOverrideStyle } from "./VfStoryModal.style";
import Modal from "../Modal/modal";
var VfStoryModal = function(param) {
    var isOpen = param.isOpen, handleClose = param.handleClose, children = param.children;
    useEffect(function() {
        var closeOnEscapeKey = function(e) {
            return e.key === "Escape" ? handleClose === null || handleClose === void 0 ? void 0 : handleClose() : null;
        };
        document.body.addEventListener("keydown", closeOnEscapeKey);
        return function() {
            document.body.removeEventListener("keydown", closeOnEscapeKey);
        };
    }, [
        handleClose
    ]);
    if (!isOpen) return null;
    return /*#__PURE__*/ _jsx(Portal, {
        wrapperId: "vf-story-modal",
        children: /*#__PURE__*/ _jsxs(WrapperOverrideStyle, {
            wrapperId: "vf-story-modal",
            children: [
                /*#__PURE__*/ _jsx(OverlayGlobalStyle, {}),
                /*#__PURE__*/ _jsx(Modal, {
                    show: isOpen,
                    onCloseModal: handleClose,
                    children: children
                })
            ]
        })
    });
};
export default VfStoryModal;
